<template>
  <div>
    <div class="redirect">ページ遷移するまで少々お待ちください...</div>
    <img src="../assets/display_logo1.jpg" alt="背景画像" />
  </div>

  <!--
     https://lightblue-link-service.lightblue-tech.com/motion_analysis_youtube/?utm_source=mailmagazin&utm_medium=email&utm_campaign=daiwa_securities



     -->
</template>

<script>
export default {
  name: "MotionAnalysisYoutube",
  components: {},
  data() {
    return {};
  },
  created: function() {},
  computed: {},
  methods: {}
};
</script>

<style scoped>
.redirect {
  font-size: 2vw;
  font-weight: bold;
  margin-bottom: 5vw;
}
</style>
